import React from 'react'
import { BaseView } from '@/components/base'

interface SeparatorProps {
  style?: React.CSSProperties
}

export const Separator: React.FC<SeparatorProps> = ({ style }) => {
  return (
    <BaseView
      style={{
        width: '100%',
        height: '1px',
        backgroundColor: '#47484A',
        ...style,
      }}
    />
  )
}

export default Separator
